import { TradingPair } from "shared/model";
import { getStoredPair } from "./pairSessionStorage";
import { pickFirstMarketOpenPair } from "./pickFirstMarketOpenPair";

export type ResolveInitialPairInput = {
  userId: number;
  currencyPairs: TradingPair[];
  selectedPair: string | null;
  /** Последний symbol из GET settings (t=16) — только для cold start. */
  savedSymbol?: string | null;
  /** t=8: только sessionStorage; global symbol ждём на t=16. */
  sessionStorageOnly?: boolean;
};

const matchListedSymbol = (
  candidate: string,
  currencyPairs: TradingPair[],
): string | null => {
  if (currencyPairs.some((p) => p.symbol === candidate)) {
    return candidate;
  }
  const upper = candidate.toUpperCase();
  return currencyPairs.find((p) => p.symbol === upper)?.symbol ?? null;
};

/**
 * Cold start: sessionStorage → savedSymbol (t=16, один раз) → market-open.
 * null — если пара на вкладке уже выбрана или ждём t=16 (sessionStorageOnly).
 */
export const resolveInitialPair = ({
  userId,
  currencyPairs,
  selectedPair,
  savedSymbol,
  sessionStorageOnly = false,
}: ResolveInitialPairInput): string | null => {
  if (selectedPair) return null;

  const stored = getStoredPair(userId);
  if (stored) {
    const matched = matchListedSymbol(stored, currencyPairs);
    if (matched) return matched;
  }

  if (sessionStorageOnly) {
    return null;
  }

  if (savedSymbol) {
    const matched = matchListedSymbol(savedSymbol, currencyPairs);
    if (matched) return matched;
  }

  return pickFirstMarketOpenPair(currencyPairs);
};
